import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { TooltipService } from '@shared/directives/tooltip/tooltip.service';
import { TooltipPosition, TooltipTheme } from './tooltip.enums';

@Component({
  selector: 'tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TooltipComponent implements OnInit {
  position: TooltipPosition = TooltipPosition.DEFAULT;
  theme: TooltipTheme = TooltipTheme.DEFAULT;
  tooltip = '';
  left = 0;
  top = 0;
  visible = false;

  constructor(
    private _tooltipService: TooltipService,
    private _cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this._tooltipService.reloadTooltip$.subscribe((val) => {
      // @ts-ignore
      this.left = val.left;
      // @ts-ignore
      this.top = val.top;
      // @ts-ignore
      this.tooltip = val.tooltip;
      // @ts-ignore
      this.visible = val.visible;
      // @ts-ignore
      this.position = val.position;
      this._cdr.detectChanges();
    });
  }
}
